<template>
    <div>
        {{ this.health }}
    </div>
</template>

<script>
import healthService from "@/service/HealthService"

export default {
    data() {
        return {
            health: 'Sem retorno'
        }
    },
    async mounted() {
        this.health = await healthService.testarBanco()
    }
}
</script>